export const PUBLIC_KEY= `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0HYW64usXSOnIpSCQle5
m+C6b5Ti2rfxITmCMBcFau8NisT4FWEhJx6+4Gfq3y9MadztS66rglse4yZyDbeQ
CWCoiYmT6u4tWEKkIkdVRCo1V86/kOgcj+ekX51eFLegSEjBv8WsH7hfYpTVGGkQ
swZnVQP8phW91FkuGMvEKbTZwR8aC9ekb05x2+jchs021dn5dT2QirG7ZfvXny/9
l9i5+5v6pdem2llS69Yilc9vvCYigPnM0l9tL0rnjDG7YKInN8bdOyvk7rj0qH4Z
rnELXtkCnzBFDJEAzTWewzFeO5pH3PDX84vwuww3MSHvmxn96K2zm0/Y6W/KVtYg
/wIDAQAB
-----END PUBLIC KEY-----
`;